import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paginationDefault } from 'constants/pagination';
import { TResponsePagination } from 'libs/axios';
import { TPagination } from 'types/common';
import { TTemplateDetail } from 'types/templates';

export type TTemplatesState = {
  templates: TTemplateDetail[];
  pagination: TPagination;
  templatesAll: TTemplateDetail[];
};

const initialState: TTemplatesState = {
  templates: [],
  pagination: paginationDefault(),
  templatesAll: [],
};

const _module = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    saveTemplates(state: TTemplatesState, action: PayloadAction<TResponsePagination<TTemplateDetail>>) {
      const { results, ...pagination } = action.payload;
      return {
        ...state,
        templates: results,
        pagination,
      };
    },
    saveTemplatesAll(state: TTemplatesState, action: PayloadAction<TTemplateDetail[]>) {
      return {
        ...state,
        templatesAll: action.payload,
      };
    },
    deleteTemplate(state: TTemplatesState, action: PayloadAction<TTemplateDetail>) {
      const pagination = { ...state.pagination };
      return {
        ...state,
        templates: state.templates.filter((u) => u.id !== action.payload.id),
        pagination: { ...pagination, totalResults: pagination.totalResults - 1 },
      };
    },
  },
});

export const templatesModule = _module;
